export const Action = {
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
  REGISTER: "REGISTER"
};
export const Mutation = {
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT"
};
